export const SIDEBAR_ROUTER_OUTLET_NAME = 'sidebar';

export enum SidebarComponentType {
  Asset = 'asset',
  FileTree = 'file-tree',
}
